module.exports = __webpack_public_path__ + "static/media/rg-back.695f4b6a.png";